import { deleteInventorySupplier } from "../../api/inventoryService";

export const useDeleteInventorySupplier = (successCallback) => {
    const remove = async (id) => {
        try {
            await deleteInventorySupplier(id);
            successCallback();
        } catch (error) {
            console.error("Failed to delete inventory supplier:", error);
            throw error;
        }
    };

    return { remove };
};